module.exports = __webpack_public_path__ + "img/antes_despues_55.eca9ac40.png";